<script lang="ts">
    import { translatePath } from "../../../../operationMapping"
    import Icon from "../../../widgets/Icon.svelte"
    import { mdiInformationVariant } from "@mdi/js"
    import Modal from "../../../widgets/Modal.svelte"
    import { _ } from "svelte-i18n" // Import the i18n function

    export let item
    let showOperationChanges: { actions: any } | null

    const getPrevious = (previous: string, current = "previous") => {
        if (previous == "null")
            return current == "current"
                ? $_("components.operationProtocol.noCurrentEntry")
                : $_("components.operationProtocol.noPreviousEntry")
        if (previous == "true") return $_("general.yes")
        if (previous == "false") return $_("general.no")
        if (previous == "0") return $_("general.no")
        if (previous == "100") return $_("general.yes")
        if (typeof previous == "string") return previous.replaceAll(/<[^>]*>/g, "")
        return previous
    }

    function isNumeric(str: string | number) {
        if (typeof str != "string") return false
        // @ts-ignore
        return !isNaN(str) && !isNaN(parseFloat(str))
    }
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
    class="btn offer-changed-text"
    style="justify-content: flex-start !important; "
    on:keydown
    on:click="{() => {
        showOperationChanges = item
    }}"
>
    {$_("components.operationProtocol.details")}
    <Icon path="{mdiInformationVariant}" />
</div>

{#if showOperationChanges}
    <Modal show="{true}" on:close="{() => (showOperationChanges = null)}" showCloseIcon="{true}">
        <div slot="header">{$_("components.operationProtocol.operationChanges")}</div>
        <div class="operation-changes">
            <div class="grid-container">
                <div class="row headline">
                    <div class="grid-item header mobile-hide">{$_("components.operationProtocol.fieldName")}</div>
                    <div class="grid-item header">{$_("components.operationProtocol.previousValue")}</div>
                    <div class="grid-item header">{$_("components.operationProtocol.currentValue")}</div>
                </div>
                {#each showOperationChanges?.actions || [] as log, i (i)}
                    <div class="row items">
                        <div class="grid-item">
                            <div class="header">{$_("components.operationProtocol.fieldName")}</div>
                            <div>{@html translatePath(log.field)}</div>
                        </div>
                        <div class="grid-item">
                            <div class="header">{$_("components.operationProtocol.previousValue")}</div>
                            <div>
                                {isNumeric(getPrevious(log.previous))
                                    ? Number(getPrevious(log.previous)).toFixed(2)
                                    : getPrevious(log.previous)}
                            </div>
                        </div>
                        <div class="grid-item">
                            <div class="header">{$_("components.operationProtocol.currentValue")}</div>
                            <div>
                                {isNumeric(getPrevious(log.current, "current"))
                                    ? Number(getPrevious(log.current, "current")).toFixed(2)
                                    : getPrevious(log.current, "current")}
                            </div>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    </Modal>
{/if}
